import { useId, useState, type ReactNode } from 'react';

/** Один раскрытый пункт, разметка и переходы общего FAQ шаблона. */
export function Accordion({
  items,
  defaultOpen = null,
  onToggle,
}: {
  items: Array<{ title: string; content: ReactNode }>;
  /** Какой пункт раскрыт при первом показе. У эталона это S.open = 0 — первый (faqHTML, engine.ts:1383) */
  defaultOpen?: number | null;
  /** Раскрытый пункт сменился: его помнит владелец (FAQ_OPEN эталона — открытый вопрос остаётся при возврате) */
  onToggle?: (open: number | null) => void;
}) {
  const id = useId();
  const [open, setOpen] = useState<number | null>(defaultOpen);
  return items.map((item, index) => (
    <div key={index} className={`st-q${open === index ? ' open' : ''}`}>
      <button
        type="button"
        aria-expanded={open === index}
        aria-controls={`${id}-${index}`}
        onClick={() => {
          const next = open === index ? null : index;
          setOpen(next);
          onToggle?.(next);
        }}
      >
        <b>{item.title}</b>
        <span className="pm" aria-hidden="true">
          {/* тот же значок, что IC.plus2 эталона: 14×14, штрих 2, круглые концы */}
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <path d="M12 5v14" />
            <path d="M5 12h14" />
          </svg>
        </span>
      </button>
      {/* inert нет: у эталона (BotCore.faq.html) его нет, а сверка в inert-поддерево не заходит
          и вся свёрнутая половина гармошки считалась отсутствующей. aria-hidden оставлен —
          он не влияет на порядок обхода, внутри только текст. */}
      <div className="a" id={`${id}-${index}`} aria-hidden={open !== index}>
        <div>
          <p>{item.content}</p>
        </div>
      </div>
    </div>
  ));
}
